// SCSS
import '../Actions.scss';
// Models
import { ExecuteTemplateActionSettings } from '../../../models/ExecuteTemplateActionSettings';
import { DEFAULT_VARIABLES_NAMES } from '../../../services/BuilderService';
// Controllers
import { ActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/ActionController';
export class ExecuteTemplateActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', '$translate', 'UndoRedoService', 'CurrentApplicationService', 'state', '$rootScope', '$scope', 'typeOfAction'];
    constructor(close, action, $onStateChanged, $translate, UndoRedoService, CurrentApplicationService, state, $rootScope, $scope, typeOfAction) {
        super(close, action, $onStateChanged, UndoRedoService, state, $rootScope, $scope, typeOfAction);
        this.$translate = $translate;
        this.UndoRedoService = UndoRedoService;
        this.CurrentApplicationService = CurrentApplicationService;
        this.state = state;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.onChangeTemplate = (event) => {
            this.action.settings.template = event.detail?.value;
            this.save();
        };
        this.onChangeOutputVariable = (event) => {
            this.action.settings.outputVariable = event.detail?.value;
            this.save();
        };
        this.onChangeInputVariables = (event) => {
            this.action.settings.inputVariables = event.detail?.data;
            this.save();
        };
        this.init();
    }
    async init() {
        this.inputVariables = this.action.settings.inputVariables;
        this.defaultVariables = DEFAULT_VARIABLES_NAMES.map(label => ({ label, value: label }));
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
    }
    create() {
        return new ExecuteTemplateActionSettings();
    }
    onBlurActionTitle() {
        this.isEditing = false;
        if (this.action.$title.length === 0) {
            this.action.$title = this.$translate.instant('builder-tabs-actions.executeTemplate.title');
            this.save();
        }
    }
    onClickActionTitle() {
        const input = document.getElementById('execute-template-title');
        if (input) {
            input.focus();
        }
    }
}
ExecuteTemplateActionController.$inject = ['close', 'action', '$onStateChanged', '$translate', 'UndoRedoService', 'CurrentApplicationService', 'state', '$rootScope', '$scope', 'typeOfAction'];
